import BlockEditorContentlet from '../shared/blockEditorContentlet';

function Blog({ attrs }) {
    if (!attrs?.data) {
        return null;
    }

    return (
        <BlockEditorContentlet
            contentType={'Blog'}
            url={'/blog/' + attrs.data.urlTitle}
            image={attrs.data.image}
            description={attrs.data.teaser}
            title={attrs.data.title}
        />
    );
}

export default Blog;
